import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
import validateUUID from "uuid-validate";
import { toast, SemanticToastContainer } from 'react-semantic-toasts';
import { useProducts } from '../../../providers/ProductProvider';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Products';

const fontStyles = {
    display: 'flex',
    fontSize: '20px',
    color: '#153A4B',
};

const priceBoxStyle = {
    borderRadius: '7px',
    border: 'solid',
    outline: 'none',
    borderColor: '#00A7B5',
    boxShadow: '.5px .5px 2px #00A7B5',
    marginTop: '5px',
    marginBottom: '20px',
    color: '#153A4B',
    display: 'flex',
    height: '25px',
    borderWidth: 'thin',
    padding: '5px',
    width: '97%',
    fontSize: '20px',
};

const toastSection = {
    marginTop: '1%'
};

export const ProductCreate = () => {
    const { checkAuth, getUserType } = useAuth();

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState();
    const [type, setType] = useState();
    const [occurrence, setOccurrence] = useState();
    const [units, setUnits] = useState();
    const [componentId, setComponentId] = useState("");
    const { createProduct, productTypes, productOccurrences, productUnits } = useProducts();
    const { isSystemAdmin } = useAuth();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    const handleSubmit = e => {
        if (componentId === "" || validateUUID(componentId)) {
            createProduct(name, price, description, type, occurrence, units, componentId)
            .then(res => {
                navigate('/products')
            });
        }
        else {
            toast({
                type: 'error',
                description: 'Component ID should be a valid UUID',
                animation: 'fade down',
                time: 5000
            });
        }
        e.preventDefault();
    };

    return (
        <div>
            <div style={{ fontSize: '35px', color: '#153A4B' }}>
                <p style={{ margin: '15px 15px 15px 0px' }}>Create a Product</p>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="createGreyBox">
                    <div className="productDetails" style={{ width: '80%' }}>
                        <div className="productName">
                            <label style={fontStyles}>Product Name</label>
                            <input
                                type="text"
                                name="ProductName"
                                id="ProductName"
                                placeholder="Product Name"
                                maxLength="50"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                required
                            />
                        </div>
                        { 
                            isSystemAdmin &&
                            <div className="componentId">
                                <label style={fontStyles}>Component Id</label>
                                <input
                                    type="text"
                                    name="ComponentId"
                                    id="ComponentId"
                                    placeholder="Component Id"
                                    value={componentId}
                                    onChange={e => setComponentId(e.target.value)}
                                />
                            </div>
                        }
                        <div className="productType">
                            <label style={fontStyles}>Type</label>
                            <select
                                name="ProductType"
                                id="ProductType"
                                value={type}
                                onChange={e => setType(e.target.value)}
                                required
                                defaultValue={""}
                            >
                                <option value="" disabled hidden>Select Type</option>
                                {productTypes.map((productType) => {
                                    return (
                                        <option key={productType} value={productType}>{productType}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="productOccurrence">
                            <label style={fontStyles}>Occurrence</label>
                            <select
                                name="ProductOccurrence"
                                id="ProductOccurrence"
                                value={occurrence}
                                onChange={e => setOccurrence(e.target.value)}
                                required
                                defaultValue={""}
                            >
                                <option value="" disabled hidden>Select Occurrence</option>
                                {productOccurrences.map((productOccurrence) => {
                                    return (
                                        <option key={productOccurrence} value={productOccurrence}>{productOccurrence}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="currency-field" style={fontStyles}>
                                Price
                            </label>
                            <NumericFormat
                                value={price}
                                displayType={'input'}
                                thousandSeparator={true}
                                prefix={'$'}
                                onValueChange={values => setPrice(values.value)}
                                style={priceBoxStyle}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                isNumericString={true}
                                required
                            />
                        </div>
                        <div className="productUnit">
                            <label style={fontStyles}>Unit</label>
                            <select
                                name="ProductUnit"
                                id="ProductUnit"
                                value={units}
                                onChange={e => setUnits(e.target.value)}
                                required
                                defaultValue={""}
                            >
                                <option value="" disabled hidden>Select Unit</option>
                                {productUnits.map((productUnit) => {
                                    return (
                                        <option key={productUnit} value={productUnit}>{productUnit}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div>
                            <label style={fontStyles}>Description</label>
                            <textarea
                                id="description"
                                name="Description"
                                rows="4"
                                cols="50"
                                placeholder="Product description..."
                                maxLength="500"
                                style={{
                                    fontFamily: 'FranklinGothic-Light',
                                    color: '#153A4B',
                                    fontSize: '20px',
                                }}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </div>
                        <div className="buttons" style={{ justifyContent: 'center' }}>
                            <button name="Save" className="Save" value="Save">
                                Save
                            </button>
                            <Link to="/products">
                                <button type="button" name="Cancel" className="Cancel" value="Cancel">
                                    Cancel
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div style={toastSection}>
                        <SemanticToastContainer position="bottom-center" />
                    </div>
                </div>
            </form>
        </div>
    );
};
